import { TableComment } from "../../../general/src/TableComment";
import { CommodityImage } from "../CommodityImage";
import { DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCommodity extends Layout {
    dataheaderCommodity: DataHeader;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    labelAcceptableVariances: Label;
    labelTemperatureRange: Label;
    layoutAttachment: CommodityImage;
    layoutTableComments: TableComment;
    panelAcceptableVariances: Panel;
    panelCommodityGeneral: Panel;
    panelCommodityHazmat: Panel;
    panelCommodityLTL: Panel;
    panelCommodityTemperature: Panel;
    panelTempRange: Panel;
    panelTempRight: Panel;
    sourceComments: DataSource;
    sourceCommodity: DataSource;
    sourceCommodityImage: DataSource;
    sourcePackagingType: DataSource;
    switchCubicUnitsPerPiece: Switch;
    switchHandlingUnitsPerPiece: Switch;
    switchHazmat: Switch;
    switchHazmatRouting: Switch;
    switchPoisonInhalationHazard: Switch;
    switchResidue: Switch;
    switchSpotsPerPiece: Switch;
    switchValuePerPiece: Switch;
    switchWeightIsPerPiece: Switch;
    tabComments: Tab;
    tabGeneral: Tab;
    tabHazmat: Tab;
    tabLTL: Tab;
    tabTemperature: Tab;
    tabsetCommodity: Tabset;
    textboxContactName: Textbox;
    textboxContactType: Textbox;
    textboxCubicUnits: Textbox;
    textboxDescr: Textbox;
    textboxERGNumber: Textbox;
    textboxEmergencyNumber: Textbox;
    textboxFgiValue: Textbox;
    textboxHandlingUnits: Textbox;
    textboxHazmatNumber: Textbox;
    textboxHazmatQtyCode: Textbox;
    textboxHeight: Textbox;
    textboxId: Textbox;
    textboxLength: Textbox;
    textboxMaxTemp: Textbox;
    textboxMinTemp: Textbox;
    textboxNmfcClassCode: Textbox;
    textboxNmfcCode: Textbox;
    textboxPackagingGroup: Textbox;
    textboxPackagingTypeCode: Textbox;
    textboxPlacardRequired: Textbox;
    textboxPrimaryHazardClass: Textbox;
    textboxProductSku: Textbox;
    textboxProperShippingName: Textbox;
    textboxReqSpots: Textbox;
    textboxReturnTemp: Textbox;
    textboxSetPoint: Textbox;
    textboxSetPointTemp: Textbox;
    textboxSignoffText: Textbox;
    textboxSubsidiaryHazardClass: Textbox;
    textboxTrainingUrl: Textbox;
    textboxTypeCode: Textbox;
    textboxWeight: Textbox;
    textboxWeightUomTypeCode: Textbox;
    textboxWidth: Textbox;
    textboxZone: Textbox;
}
